import { checkEnvironment } from '@saviynt/common';

const getSessionsAccountScheduleUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/sessions/schedule`;
};

export default getSessionsAccountScheduleUrl;
